<template>
    <div class="sc-form ">
        <form v-on:submit.prevent>
            <div class="header" v-if="hasHeader">
                <slot name="header">
                    {{ form.name }}
                </slot>
            </div>
            <div class="form-content" :class="{pd:padded}">
                <slot>
                    <template v-if="form">
                        <div class="row" v-for="(val,key) in form.constructors">

                            <slot :name="'field-' + key" :field="val">
                                <sc-form-field :field="key" :name="val.name" :form="form"
                                               :description="val.description">

                                    <template v-if="val.component">
                                        <component :is="val.component" :form="form" :field="key"
                                                   :options="val.options"></component>
                                    </template>

                                    <template v-else-if="val.type === 'boolean'">
                                        <sc-form-field-boolean :field.sync="form.fields[key]"/>
                                    </template>

                                    <template v-else-if="val.type === 'select'">
                                        <select v-model="form.fields[key]">
                                            <option v-for="(optionName, optionVal) in val.options" :value="optionVal">
                                                {{ optionName }}
                                            </option>
                                        </select>
                                    </template>

                                    <template v-else>
                                        <input :ref="'field-' + key" v-model="form.fields[key]"/>
                                    </template>
                                </sc-form-field>
                            </slot>

                        </div>
                    </template>
                </slot>
            </div>
            <slot name="buttons">
                <div class="buttons pdw">
                    <sc-button icon="save"
                               :disabled="form.processing"
                               :running="form.processing"
                               @click="$emit('submit')">Submit
                    </sc-button>
                </div>
            </slot>
        </form>
    </div>
</template>

<script>
import ScFormField from "./sc-form-field";

export default {
  inheritAttrs: false,
  name: "sc-form",
  components: {ScFormField},
  props: {
    form: {},
    padded: {
      default: true,
    }
  },
  computed: {
    hasHeader() {
      return !!this.$slots['header'] || !!this.form.name
    },
  },
  mounted() {
    if (this.form && this.form.fields) {
      if (!Object.entries(this.form.fields)[0] && Object.entries(this.form.fields)[0][0]) return;
      let field = Object.entries(this.form.fields)[0][0];
      this.$nextTick(() => {
        let ref = this.$refs['field-' + field]
        if (ref && ref[0]) {
          ref[0].focus();
        }
      })

    }
  }
}
</script>

<style scoped lang="scss">
.sc-form {

    //form {
    //    background: #fff;
    //    box-shadow: $shading;
    //    border-radius: 0.3em;
    //}
    //
    //.header {
    //    font-size: 1.2em;
    //}
    //
    //.buttons {
    //    padding-bottom: 28px;
    //    display: flex;
    //    justify-content: flex-end;
    //}
}
</style>